import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  Paper,
  Avatar,
  AvatarGroup,
  Divider,
  Chip,
  Container,
  ImageListItem,
  ImageList,
  Modal,
  Dialog,
  DialogContent,
  DialogActions,
  useTheme,
  useMediaQuery,
  DialogTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Checkbox,
  Dialog as MuiDialog, DialogContent as MuiDialogContent, DialogTitle as MuiDialogTitle, Button as MuiButton, Typography as MuiTypography,
  CircularProgress
} from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EventIcon from "@mui/icons-material/Event";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PeopleIcon from "@mui/icons-material/People";
// import VideocamIcon from "@mui/icons-material/Videocam";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import GroupsIcon from "@mui/icons-material/Groups";
import TicketBookingModal from "./TicketBookingModal.js";
import { useDispatch } from "react-redux";
import {
  deleteEvent,
  getAttendeeAccessPass,
  getEventAnalytics,
  getEventAttendees,
  getInvaiteUsersEvent,
  getSingleEvent,
  getVolunteers,
  PostInvaiteUsersToEvent,
  removeUsersFromInvaite,
  updateEvent,
} from "../../../../Redux/Reducers/communityReducer";
import MapIntegration from "../../Mapintegration";
import MapWithAddress from "../../MapWithAddress";
import { getConnectedReducer } from "../../../../Redux/Reducers/ContactReducer";
import CreateEventModal from "./CreateEventModal.js";
import CloseIcon from "@mui/icons-material/Close";
import { getInterviewers } from "../../../../Redux/Reducers/JobReducer.js";
import { ShareProfile } from "../../MyProfileDetails/ProfileConnectionComponents.js";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import DeleteIcon from '@mui/icons-material/Delete'; // Added import
import TicketCard from "./TicketCard.js";
import { useQuantityContext } from "../../../QuantityContext.js";
import EventSkeleton from "../../../LoadingSkeleton/EventSkeleton.js";
import { Helmet } from "react-helmet";
import { MdOutlineAnalytics } from "react-icons/md";
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import WorkIcon from '@mui/icons-material/Work';
import WifiIcon from '@mui/icons-material/Wifi';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

// Sample attendees data
const SAMPLE_ATTENDEES = [
  {
    id: 1,
    name: "Alex Johnson",
    avatar: "https://randomuser.me/api/portraits/men/41.jpg",
  },
  {
    id: 2,
    name: "Samantha Lee",
    avatar: "https://randomuser.me/api/portraits/women/22.jpg",
  },
  {
    id: 3,
    name: "Michael Chen",
    avatar: "https://randomuser.me/api/portraits/men/64.jpg",
  },
  {
    id: 4,
    name: "Emily Rodriguez",
    avatar: "https://randomuser.me/api/portraits/women/53.jpg",
  },
  {
    id: 5,
    name: "David Kim",
    avatar: "https://randomuser.me/api/portraits/men/75.jpg",
  },
  {
    id: 6,
    name: "Olivia Patel",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    id: 7,
    name: "James Wilson",
    avatar: "https://randomuser.me/api/portraits/men/28.jpg",
  },
  {
    id: 8,
    name: "Sophia Garcia",
    avatar: "https://randomuser.me/api/portraits/women/65.jpg",
  },
];

// Helper functions
const formatTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

const formatDuration = (start, end) => {
  const startTime = formatTime(start);
  const endTime = formatTime(end);
  return `${startTime}- ${endTime}`;
};

const getGMTOffset = () => {
  const offset = -new Date().getTimezoneOffset() / 60;
  return `GMT${offset >= 0 ? "+" : ""}${offset}:00`;
};

const EventDetailHeader = ({ event }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("IAMEVENT", event )

  const handleBack = () => {
    // Read the "from" source passed via navigation state
    const from = location;

    if (from === "my-feeds") {
      // Came from CommunityProfileTabs (My Events tab)
      navigate(`/my-feeds?tab=fourth`, {
        state: { scrollToEventId: event.id },
      });
    } else {
      // Default fallback — came from community global Events tab
      navigate(`/community?tab=fourth`, {
        state: { scrollToEventId: event.id },
      });
    }
  };

  return (
    <Box sx={{ position: "relative", mb: 4 }}>
      <Box
        component="img"
        src={event?.feature_image}
        alt={event?.title}
        sx={{
          width: "100%",
          height: { xs: 250, sm: 350, md: 450 },
          objectFit: "cover",
          borderRadius: 2,
        }}
      />

      <IconButton
        // onClick={() => navigate("/community?tab=fourth", {
        //   state: { scrollToEventId: event.id }
        // })}
        onClick={() => navigate(-1)}
        // onClick={handleBack}
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          bgcolor: "background.paper",
          "&:hover": { bgcolor: "background.default" },
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <Chip
        label={event?.event_category}
        color="primary"
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          fontWeight: "bold",
          fontSize: "0.875rem",
          background: "#0044C6"
        }}
      />
    </Box>
  );
};

const EventDetails = ({ event }) => {
  console.log('eventNNNNNN', event)
  const [expanded, setExpanded] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const descRef = useRef();
  const gmtOffset = getGMTOffset();
  const isOnline = event.mode === "Online";

  // Truncate description to 200 characters initially
  const maxLength = 200;
  const shouldTruncate = event?.description?.length > maxLength;
  const displayDescription = expanded
    ? event?.description
    : event?.description?.substring(0, maxLength) +
    (shouldTruncate ? "..." : "");

  useEffect(() => {
    const descElement = descRef.current;
    if (descElement) {
      const lineHeight = parseFloat(
        window.getComputedStyle(descElement)?.lineHeight
      );
      const maxHeight = lineHeight * 3; // 3 lines
      const isContentHidden = descElement.scrollHeight > maxHeight;
      setIsButtonVisible(isContentHidden);
    }
  }, [event.description, expanded]);

  const isSameDay = (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  };


  return (
    <Paper elevation={0} sx={{ borderRadius: 2, p: 3, mb: 3 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        {event?.title}
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Box>
          <Typography variant="body1" fontWeight="medium">
            By {event?.organizer?.name}
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <EventIcon sx={{ mr: 1, color: "#0044C6" }} />
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                DATE & TIME
              </Typography>
              {isSameDay(event?.start_time, event?.end_time) ? (
                // Same day: Show start date with time range
                <Typography variant="body1">
                  {formatDate(event?.start_time)} •{" "}
                  {formatDuration(event?.start_time, event?.end_time)}
                </Typography>
              ) : (
                // Different days: Show both start and end dates with times
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Typography variant="body1">
                    <strong>Start:</strong> {formatDate(event?.start_time)} • {formatTime(event?.start_time)}
                  </Typography>
                  <Typography variant="body1">
                    <strong>End:</strong> {formatDate(event?.end_time)} • {formatTime(event?.end_time)}
                  </Typography>
                </Box>
              )}
              {/* <Typography variant="body2" color="text.secondary">
    {gmtOffset}
  </Typography> */}
            </Box>
          </Box>
        </Grid>



        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
            {isOnline ? (
              <WifiIcon color="primary" sx={{ mr: 1, mt: 0.5, color: "#0044C6" }} />
            ) : (
              <FmdGoodIcon color="primary" sx={{ mr: 1, mt: 0.5, color: "#0044C6" }} />
            )}
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Event Type
              </Typography>
              <Typography variant="body1">
                {isOnline ? "Online" : "Offline"}
              </Typography>
            </Box>
          </Box>


          <Box sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
            <LocationOnOutlinedIcon color="primary" sx={{ mr: 1, mt: 0.5, color: "#0044C6" }} />
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                {isOnline ? "EVENT LINK" : "LOCATION"}
              </Typography>
              {event.is_registered ? (
                isOnline ? (
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ mt: 1 }}
                    onClick={() => window.open(event?.event_link, "_blank")}
                  >
                    Click here to join
                  </Button>
                ) : event?.event_location ? (
                  <Typography variant="body1">{event?.event_location}</Typography>
                ) : (
                  <Typography variant="body1">Location not specified</Typography>
                )
              ) : (
                <Typography variant="body1" color="text.secondary">
                  Register to view {isOnline ? "event link" : "location"}
                </Typography>
              )}
            </Box>
          </Box>



          {/* <Box sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
            <CurrencyRupeeIcon color="primary" sx={{ mr: 1, mt: 0.5 }} />
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                {event.is_paid ? `${event.price_currency}` : "Free"}
              </Typography>
              <>
                <Typography variant="body1">
                  {event.price_amount || 0}
                </Typography>
              </>
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mb: 2 }}>
            <GroupsIcon color="primary" sx={{ mr: 1, mt: 0.5 }} />
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                ATTENDEES
              </Typography>
              <>
                <Typography variant="body1">
                  {event.no_of_attendees || 0}
                </Typography>
              </>
            </Box>
          </Box> */}

          <Box>
            <Typography variant="h6" fontWeight="bold">
              About Event
            </Typography>

            <Typography
              ref={descRef}
              variant="body1"
              color="text.secondary"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: expanded ? "none" : 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                mb: 0, // small margin if needed
                whiteSpace: "pre-line"
              }}
              inputProps={{
                style: {
                  whiteSpace: 'pre-wrap'  // This preserves line breaks
                }
              }}
              InputProps={{
                style: {
                  whiteSpace: 'pre-wrap'  // This preserves line breaks in the display
                }
              }}
            >
              {event?.description}
            </Typography>

            {isButtonVisible && (
              <Button
                size="small"
                sx={{ textTransform: "none", mt: 0 }}
                onClick={() => setExpanded((prev) => !prev)}
              >
                {expanded ? "See less" : "See more"}
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

const AttendeesModal = ({ open, onClose, attendees, loading }) => {
  console.log("NNNNNNNNffffffff", attendees);

  const getStatusColor = (status) => {
    switch (status?.toUpperCase()) {
      case 'APPROVED':
        return { bg: '#e8f5e9', text: '#2e7d32', };
      case 'PENDING':
        return { bg: '#fff3e0', text: '#ed6c02', };
      case 'CANCELLED':
        return { bg: '#ffebee', text: '#c62828', };
      default:
        return { bg: '#f5f5f5', text: '#757575', };
    }
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return null;
    // Format Indian phone numbers
    if (phone.startsWith('+91')) {
      return phone.replace('+91', '+91 ');
    }
    return phone;
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: '80vh'
        }
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Attendees
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {attendees?.length || 0} {attendees?.length === 1 ? 'person' : 'people'} registered
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
            <CircularProgress size={40} />
          </Box>
        ) : attendees?.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="body2" color="text.secondary">
              No attendees found.
            </Typography>
          </Box>
        ) : (
          <List sx={{ p: 0 }}>
            {attendees?.map((item, index) => {
              const attendee = item.attendee || {};
              const status = item.attendance_status || 'PENDING';
              const statusStyle = getStatusColor(status);
              const ticketId = item.ticket_id;
              const registrationDate = formatDate(item.created_at);
              const phoneNumber = formatPhoneNumber(attendee.phone);

              return (
                <React.Fragment key={item.id || index}>
                  <ListItem
                    sx={{
                      py: 2.5,
                      px: 3,
                      transition: 'all 0.2s',
                      '&:hover': {
                        bgcolor: 'action.hover'
                      }
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar
                        src={attendee.profile_url}
                        alt={attendee.name}
                        sx={{
                          width: 52,
                          height: 52,
                          bgcolor: 'primary.main',
                          fontSize: '1.25rem'
                        }}
                      >
                        {attendee.name ? attendee.name.charAt(0).toUpperCase() : "?"}
                      </Avatar>
                    </ListItemAvatar>

                    <Box sx={{ flex: 1, ml: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                          {attendee.name || "Unknown"}
                        </Typography>
                        <Chip
                          label={status}
                          size="small"
                          // icon={<span style={{ fontSize: '12px' }}>{statusStyle.icon}</span>}
                          sx={{
                            backgroundColor: statusStyle.bg,
                            color: statusStyle.text,
                            fontWeight: 600,
                            fontSize: '0.7rem',
                            height: '28px',
                            '& .MuiChip-label': {
                              px: 1,
                              fontWeight: 600
                            }
                          }}
                        />
                      </Box>

                      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, display: 'flex', alignItems: 'center', gap: 1 }}>
                        <EmailIcon sx={{ fontSize: 14 }} />
                        {attendee.email || "Email not available"}
                      </Typography>

                      {phoneNumber && (
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, display: 'flex', alignItems: 'center', gap: 1 }}>
                          <PhoneIcon sx={{ fontSize: 14 }} />
                          {phoneNumber}
                        </Typography>
                      )}

                      {attendee.designation && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <WorkIcon sx={{ fontSize: 12 }} />
                          {attendee.designation}
                          {attendee.company && ` at ${attendee.company}`}
                        </Typography>
                      )}

                      <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                        {ticketId && (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <ConfirmationNumberIcon sx={{ fontSize: 12 }} />
                            Ticket: {ticketId}
                          </Typography>
                        )}
                        {registrationDate && (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <EventIcon sx={{ fontSize: 12 }} />
                            Registered: {registrationDate}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </ListItem>
                  {index < attendees?.length - 1 && <Divider sx={{ mx: 3 }} />}
                </React.Fragment>
              );
            })}
          </List>
        )}
      </DialogContent>

      {attendees?.length > 0 && (
        <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid', borderColor: 'divider' }}>
          <Button
            onClick={onClose}
            variant="contained"
            size="small"
            sx={{ borderRadius: 2 }}
          >
            Close
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

const AttendeesSection = ({ attendees, limit, event }) => {
  const dispatch = useDispatch();
  const visibleAttendees = attendees.slice(0, 4);
  const extraCount = attendees?.length - visibleAttendees?.length;
  const [isAttendeesModalOpen, setIsAttendeesModalOpen] = useState(false);
  const EventAttendees = useSelector((state) => state.community.EventAttendees);
  const [isAttendeesLoading, setIsAttendeesLoading] = useState(false);


  const handleAttendeesClick = async () => {
    setIsAttendeesLoading(true); // Set attendees loading
    try {
      await dispatch(getEventAttendees(event.id));
      setIsAttendeesModalOpen(true);
    } catch (error) {
      console.error("Failed to fetch attendees:", error);
    } finally {
      setIsAttendeesLoading(false); // Clear loading state
    }
  };

  return (
    <Paper elevation={0} sx={{ borderRadius: 2, p: 3, mb: 1 }}>
      {event?.is_my_event ? (
        <Typography
          variant="h6"
          fontWeight="bold"
          gutterBottom
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={handleAttendeesClick}
        >
          <PeopleIcon sx={{ mr: 1, color: "#0044C6" }} />
          {event?.no_of_attendees} Attendees
        </Typography>
      ) : (
        ""
      )}
      <AttendeesModal
        open={isAttendeesModalOpen}
        onClose={() => setIsAttendeesModalOpen(false)}
        attendees={EventAttendees}
        loading={isAttendeesLoading}
      />
    </Paper>
  );
};
const InviteesSection = ({ attendees, limit, event }) => {
  const dispatch = useDispatch();
  const visibleAttendees = attendees.slice(0, 4);
  const extraCount = attendees?.length - visibleAttendees?.length;
  const [isAttendeesModalOpen, setIsAttendeesModalOpen] = useState(false);
  const getInviteUserEvent = useSelector((state) => state.community.getInviteUserEvent);

  const handleAttendeesClick = () => {
    const params = {
      id: event.id,
      page: 0
    }
    dispatch(getInvaiteUsersEvent(params));
    setIsAttendeesModalOpen(true);
  };

  return (
    <Paper elevation={0} sx={{ borderRadius: 2, p: 3, mb: 3 }}>
      {event?.is_my_event ? (
        <Typography
          variant="h6"
          fontWeight="bold"
          gutterBottom
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={handleAttendeesClick}
        >
          <GroupAddIcon sx={{ mr: 1, color: "#0044C6" }} />
          {event?.no_of_invited_users} Invited Users
        </Typography>
      ) : (
        ""
      )}
      <InvitesModal
        open={isAttendeesModalOpen}
        onClose={() => setIsAttendeesModalOpen(false)}
        attendees={getInviteUserEvent}
        eventId={event?.id}
      />
    </Paper>
  );
};

const InvitesModal = ({ open, onClose, attendees, eventId, loading }) => {
  const [invitees, setInvitees] = useState([]);
  const [selectedInvitees, setSelectedInvitees] = useState([]);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [invitedUsers, setInvitedUsers] = useState([]);
  const [error, setError] = useState(null);
  const allUsers = useSelector(state => state.ContactArray.ConnectedContact) || [];
  const dispatch = useDispatch();


  // Sync with Redux data when modal opens
  useEffect(() => {
    if (open) {
      setInvitees(attendees || []);
      setSelectedInvitees([]);
      setSelectAll(false);
    }
  }, [open, attendees]);

  const handleSelectInvitee = (id) => {
    if (selectedInvitees.includes(id)) {
      setSelectedInvitees(selectedInvitees.filter(inviteeId => inviteeId !== id));
    } else {
      setSelectedInvitees([...selectedInvitees, id]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedInvitees([]);
    } else {
      setSelectedInvitees(invitees.map(invitee => invitee.id));
    }
    setSelectAll(!selectAll);
  };

  const handleDeleteSelected = () => {
    if (selectedInvitees.length === 0) return;
    setIsDeleteConfirmOpen(true);
  };

  const confirmDelete = async () => {
    // Format selected IDs as pipe-separated string
    const invitationIds = selectedInvitees.join('|');

    // Prepare API parameters
    const params = {
      id: eventId,
      invitation_ids: invitationIds
    };

    // Dispatch API call to delete invitees
    await dispatch(removeUsersFromInvaite(params))
      // await dispatch(getInvaiteUsersEvent({ id: eventId, page: 0 }));
      .then(() => {
        // Refetch updated invitees list
        dispatch(getInvaiteUsersEvent({ id: eventId, page: 0 }));

      })
      .catch(error => {
        console.error("Delete invitees error:", error);

      })
      .finally(() => {
        setSelectedInvitees([]);
        setSelectAll(false);
        setIsDeleteConfirmOpen(false);
      });
  };

  const handleAddInvitees = () => {
    setShowInviteModal(true);
  };

  const toggleInviteUser = (contactRefId) => {
    setInvitedUsers(prev =>
      prev.includes(contactRefId)
        ? prev.filter(id => id !== contactRefId)
        : [...prev, contactRefId]
    );
  };

  const handleInviteSubmit = async () => {
    setError(null);

    if (invitedUsers.length === 0) {
      setError("Please select at least one user");
      return;
    }

    const params = {
      id: eventId,
      invited_user_ids: invitedUsers
    };

    try {
      await dispatch(PostInvaiteUsersToEvent(params));
      dispatch(getInvaiteUsersEvent({ id: eventId, page: 0 }));
      setShowInviteModal(false);
      setInvitedUsers([]);
    } catch (error) {
      setError("Failed to invite users. Please try again.");
      console.error("Error inviting users:", error);
    }
  };

  // Add error display in the modal
  {
    error && (
      <Typography color="error" sx={{ p: 2 }}>
        {error}
      </Typography>
    )
  }

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">


            <Typography variant="h6">Invitees</Typography>


            <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
              <Box display="flex" alignItems="center">
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAll}
                  indeterminate={
                    selectedInvitees?.length > 0 &&
                    selectedInvitees?.length < invitees?.length
                  }
                />
                <Typography sx={{ fontSize: "16px", }}>Select All</Typography></Box>
              <IconButton onClick={onClose}>

                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          {loading ? ( // Add loading indicator
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          ) : invitees?.length === 0 ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              minHeight={200}
            >
              <GroupAddIcon sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }} />
              <Typography variant="body1" color="textSecondary">
                No invitees yet
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                sx={{ mt: 2, cursor: 'pointer' }}
                onClick={handleAddInvitees}
              >
                Add invitees
              </Typography>
            </Box>
          ) : (
            <List>
              {invitees?.map((item, index) => (
                <React.Fragment key={item.id}>
                  <ListItem
                    secondaryAction={
                      <Checkbox
                        edge="end"
                        checked={selectedInvitees.includes(item.id)}
                        onChange={() => handleSelectInvitee(item.id)}
                      />
                    }
                  >
                    <ListItemAvatar>
                      <Avatar src={item.profile_url}>
                        {item.first_name?.charAt(0)}{item.last_name?.charAt(0)}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={`${item.first_name} ${item.last_name}`}
                      secondary={
                        <>
                          {item.designation && <span>{item.designation}</span>}
                          {item.company_name && (
                            <span>{item.designation ? ', ' : ''}{item.company_name}</span>
                          )}
                        </>
                      }
                    />
                  </ListItem>
                  {index < invitees?.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          )}
        </DialogContent>

        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
          <Button
            variant="outlined"
            onClick={handleAddInvitees}
            disabled={selectedInvitees?.length > 0}
          >
            Add Users
          </Button>

          {selectedInvitees?.length > 0 && (
            <Button
              variant="contained"
              color="error"
              startIcon={<DeleteIcon />}
              onClick={handleDeleteSelected}
              sx={{ ml: 2 }}
            >
              Delete Selected ({selectedInvitees?.length})
            </Button>
          )}
        </Box>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={isDeleteConfirmOpen} onClose={() => setIsDeleteConfirmOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete {selectedInvitees?.length}
            {selectedInvitees?.length === 1 ? " invitee" : " invitees"}?
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteConfirmOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={confirmDelete}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>


      </Dialog>

      {showInviteModal && (
        <Dialog
          open={showInviteModal}
          onClose={() => setShowInviteModal(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Select Users to Invite</DialogTitle>
          <DialogContent>
            <List>
              {allUsers?.map(user => (
                <ListItem
                  key={user?.contact_ref_id}
                  dense
                  button
                  onClick={() => toggleInviteUser(user?.contact_ref_id)}
                >
                  <Checkbox
                    edge="start"
                    checked={invitedUsers.includes(user?.contact_ref_id)}
                    tabIndex={-1}
                    disableRipple
                  />
                  <ListItemAvatar>
                    <Avatar src={user?.profile_url} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={`${user?.first_name} ${user?.last_name}`}
                    secondary={user?.designation || user?.company_name ?
                      `${user?.designation ? user.designation : ''}${user?.designation && user?.company_name ? ', ' : ''}${user?.company_name ? user.company_name : ''}` :
                      ''
                    }
                  />
                </ListItem>
              ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setShowInviteModal(false)}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={handleInviteSubmit}
              color="primary"
              variant="contained"
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

const AdditionalInfo = ({ event }) => {
  const tags = [event.event_type, event.event_category].filter(Boolean);

  return (
    <Paper elevation={0} sx={{ borderRadius: 2, p: 3, mb: 3 }}>
      {tags?.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            TAGS
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {tags?.map((tag, index) => (
              <Chip
                key={index}
                label={tag}
                color="primary"
                variant="outlined"
              />
            ))}
          </Box>
        </Box>
      )}

      <Box>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          ACCESS LEVEL
        </Typography>
        <Typography variant="body1" paragraph>
          {event?.event_access_level}
        </Typography>
      </Box>
    </Paper>
  );
};

const MediaModal = ({
  open,
  onClose,
  media,
  currentIndex,
  setCurrentIndex,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < media?.length - 1 ? prev + 1 : 0));
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : media?.length - 1));
  };

  const currentMedia = media[currentIndex];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth="lg"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          bgcolor: "rgba(0,0,0,0.8)",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent
        sx={{
          p: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IconButton
          onClick={handlePrev}
          sx={{
            position: "absolute",
            left: 16,
            color: "white",
            bgcolor: "rgba(0,0,0,0.5)",
            "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
          }}
        >
          <NavigateBeforeIcon fontSize="large" />
        </IconButton>

        <Box
          sx={{
            width: "100%",
            height: isMobile ? "70vh" : "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
            boxSizing: "border-box",
          }}
        >
          {currentMedia?.type?.startsWith("image/") ? (
            <img
              src={currentMedia?.url}
              alt="Event media"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          ) : currentMedia?.type?.startsWith("video/") ? (
            <video
              src={currentMedia?.url}
              controls
              autoPlay
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
              }}
            />
          ) : currentMedia?.type === "application/pdf" ? (
            <iframe
              src={currentMedia?.url}
              title="PDF viewer"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          ) : null}
        </Box>

        <IconButton
          onClick={handleNext}
          sx={{
            position: "absolute",
            right: 16,
            color: "white",
            bgcolor: "rgba(0,0,0,0.5)",
            "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
          }}
        >
          <NavigateNextIcon fontSize="large" />
        </IconButton>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "space-between",
          p: 2,
          bgcolor: "rgba(0,0,0,0.8)",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {currentIndex + 1} of {media?.length}
        </Typography>
        <Button onClick={onClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const SingleEventScreen = () => {
  const { id } = useParams()
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openSnackbar } = useQuantityContext();
  const singleEvent = useSelector((state) => state?.community?.singleEvent);
  const [mediaModalOpen, setMediaModalOpen] = useState(false);
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editEventId, setEditEventId] = useState(null);
  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  const ProfessionalData = useSelector(
    (state) => state?.ProfileArray?.professionaProfile
  );
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [isLoading, setIsLoading] = useState(true);
  const isAuth = localStorage.getItem('objectId');
  // console.log("singleEvent13131531", singleEvent)

  useEffect(() => {
    const fetchEvent = async () => {
      setIsLoading(true); // Set loading true when starting fetch
      try {
        await dispatch(getSingleEvent(id));
      } catch (error) {
        console.error("Failed to fetch event:", error);
      } finally {
        setIsLoading(false)
      }
    };

    fetchEvent();
  }, [id]);

  // ...existing code...
  // Helper functions for ShareProfile
  const handleShareSuccess = (msg) => {
    setSnackbarMsg(msg);
    setSnackbarType("success");
  };
  const handleShareFailure = (msg) => {
    setSnackbarMsg(msg);
    setSnackbarType("error");
  };

  // Add this function to open the modal
  const handleViewAccessCard = () => {
    const ticketId = event?.registration?.ticket_id || event.event_code;
    dispatch(getAttendeeAccessPass(ticketId));
    setTicketModalOpen(true);
  };

  const isEventStarted = (startTime) => {
    if (!startTime) return false;
    const currentTime = new Date();
    return currentTime >= new Date(startTime);
  };

  if (isLoading) {
    return (
      <Container maxWidth="md" sx={{
        height: '80vh'
      }}>
        <EventSkeleton />
      </Container>
    );
  }

  if (!singleEvent) {
    return (
      <Container maxWidth="md" sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="h6">Event not found</Typography>
      </Container>
    );
  }

  // Transform API data to match component needs
  const event = {
    ...singleEvent,
    price: singleEvent?.is_paid ? singleEvent?.price_amount : 0,
    currency: singleEvent?.price_currency || "INR",
  };

  console.log("eventjhschjbsc", event?.registration?.attendance_status)

  const availableSpots = event?.attendees_limit - event?.no_of_attendees;
  const eventShareUrl = `${window.location.origin}/explore/events/${event?.id}`;
  const handleMediaClick = (index) => {
    setCurrentMediaIndex(index);
    setMediaModalOpen(true);
  };

  const handleOpenDeleteModal = () => {
    setIsDeleteModalOpen(true); // Open delete confirmation modal
    handlePopoverClose();
  };

  const handleDeleteEvent = async () => {
    try {
      await dispatch(deleteEvent(event?.id));
      setIsDeleteModalOpen(false); // Close modal after deletion
      openSnackbar("Event deleted successfully", "success", 4000);
      navigate("/community?tab=fourth");
    } catch (error) {
      console.error("Event deletion failed:", error);
      openSnackbar("Failed to delete event. Please try again.", "error", 4000);
    }
  };


  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false); // Close delete confirmation modal
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };



  const renderMediaItem = (mediaItem, index) => {

    const { type, url } = mediaItem;

    if (type.startsWith("image/")) {
      return (
        <ImageListItem
          key={index}
          onClick={() => handleMediaClick(index)}
          sx={{ cursor: "pointer" }}
        >
          <img
            src={url}
            alt={`Media ${index + 1}`}
            loading="lazy"
            style={{
              borderRadius: 8,
              height: 200,
              width: "100%",
              objectFit: "cover",
            }}
          />
        </ImageListItem>
      );
    } else if (type.startsWith("video/")) {
      return (
        <ImageListItem
          key={index}
          onClick={() => handleMediaClick(index)}
          sx={{ cursor: "pointer" }}
        >
          <Box sx={{ position: "relative", height: 200 }}>
            {/* Actual video element for preview */}
            <video
              src={url}
              style={{
                width: "100%",
                height: 200,
                objectFit: "cover",
                borderRadius: 8,
              }}
              muted
              playsInline
            />
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "rgba(0,0,0,0.3)",
                borderRadius: 1,
              }}
            >
              <PlayCircleOutlineIcon sx={{ fontSize: 48, color: "white" }} />
            </Box>
          </Box>
        </ImageListItem>
      );
    } else if (type === "application/pdf") {
      return (
        <ImageListItem
          key={index}
          onClick={() => handleMediaClick(index)}
          sx={{ cursor: "pointer" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: 200,
              bgcolor: "grey.100",
              borderRadius: 2,
              border: "1px solid",
              borderColor: "grey.300",
            }}
          >
            <Typography variant="h6" sx={{ mb: 1 }}>
              📄
            </Typography>
            <Typography variant="body2" color="text.secondary">
              PDF Document
            </Typography>
            <Button size="small" sx={{ mt: 1 }}>
              View PDF
            </Button>
          </Box>
        </ImageListItem>
      );
    }

    return null;
  };

  const MediaSection = ({ media }) => {
    if (!media || media?.length === 0) return null;

    return (
      <Paper elevation={0} sx={{ borderRadius: 2, p: 3, mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Media
        </Typography>
        <ImageList variant="masonry" cols={2} gap={8}>
          {media?.map(renderMediaItem)}
        </ImageList>
      </Paper>
    );
  };

  const handleRegistrationClick = () => {
    if (!isAuth) {
      openSnackbar("Please login to register for this event", "error", 3000);
      setTimeout(() => navigate("/login"), 3000);
      return;
    }

    if (event?.mode === "Online" && event?.is_registered) {
      window.open(event?.event_link, "_blank");
    } else {
      setBookingModalOpen(true);
      dispatch(getInterviewers(params));
    }
  };

  const handleViewDashboard = (event) => {
    dispatch(getSingleEvent(event?.id));
    dispatch(getVolunteers(event?.id));
    dispatch(getEventAttendees(event?.id));
    dispatch(getEventAnalytics(event?.id))
    navigate(`/community-dashboard/${event?.id}`)
  }


  const params = { company_name: ProfessionalData?.company_name };

  return (
    <>
      {shareModalOpen && event && (
        <Helmet>
          <meta key="og-title" property="og:title" content={event.title} />
          <meta key="og-description" property="og:description" content={`Join us on ${new Date(event.start_time).toLocaleDateString()}`} />
          <meta key="og-image" property="og:image" content={event.feature_image} />
          <meta key="og-url" property="og:url" content={`${window.location.origin}/explore/events/${event.id}`} />
          <meta key="og-type" property="og:type" content="event" />
          {event.start_time && (
            <meta key="event-start" property="event:start_time" content={new Date(event.start_time).toISOString()} />
          )}
          {event.end_time && (
            <meta key="event-end" property="event:end_time" content={new Date(event.end_time).toISOString()} />
          )}
          {event.location && (
            <meta key="event-location" property="event:location" content={event.location} />
          )}
        </Helmet>
      )}
      <Container maxWidth="md" sx={{ py: 1, }}>
        <EventDetailHeader event={event} />
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <EventDetails event={singleEvent} />
            {singleEvent?.media && singleEvent?.media?.length > 0 && (
              <MediaSection media={singleEvent?.media} />
            )}
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{ borderRadius: 2, p: 3, mb: 3, position: "sticky", top: 20 }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  Registration
                </Typography>
                <Typography variant="h6" fontWeight="bold" sx={{ color: "#0044C6" }}>
                  {event?.is_paid ? `${event?.currency} ${event?.price}` : "Free"}
                </Typography>
              </Box>

              {/* Replace the existing Registration Button block with this */}

              {event?.is_my_event ? (
                <Box>
                  {!isEventStarted(event?.start_time) && event?.no_of_attendees == 0 ? (
                    <>
                      <Button
                        variant="contained"
                        fullWidth
                        size="large"
                        sx={{ mb: 2, py: 1.5, fontWeight: "bold", background: "#0044C6" }}
                        onClick={() => setEditModalOpen(true)}
                      >
                        Edit Event
                      </Button>
                      <Button
                        variant="outlined"
                        color="error"
                        fullWidth
                        size="large"
                        sx={{ mb: 2, py: 1.5, fontWeight: "bold" }}
                        onClick={handleOpenDeleteModal}
                      >
                        Delete
                      </Button>
                    </>
                  ) : (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
                      Event has started - editing/deleting is disabled
                    </Typography>
                  )}
                </Box>
              ) : event?.is_registered && event?.registration?.attendance_status != "CANCELLED" ? (
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{ mb: 2, py: 1.5, fontWeight: "bold", background: "#0044C6" }}
                  onClick={handleViewAccessCard}
                >
                  View Access Pass
                </Button>
              ) : (
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{
                    mb: 2,
                    py: 1.5,
                    fontWeight: "bold",
                    background: event?.mode !== "Online" && event?.attendees_limit && event?.no_of_attendees >= event?.attendees_limit ? "#ccc" : "#0044C6",
                    '&.Mui-disabled': {
                      color: 'rgba(0, 0, 0, 0.6)',
                      backgroundColor: '#ccc'
                    }
                  }}
                  disabled={event?.mode !== "Online" && event?.attendees_limit && event?.no_of_attendees >= event?.attendees_limit}
                  onClick={handleRegistrationClick}
                >
                  {event?.mode === "Online" && event?.is_registered
                    ? "Join Now"
                    : (event?.attendees_limit && event?.no_of_attendees >= event?.attendees_limit)
                      ? "Seats are full"
                      : "Register Now"
                  }
                </Button>
              )}

              <Button
                variant="outlined"
                fullWidth
                size="large"
                startIcon={<ShareRoundedIcon sx={{ color: "#0044C6" }} />}
                sx={{
                  py: 1,
                  color: "#0044C6",
                  borderColor: "#0044C6", // sets the outline color
                  '&:hover': {
                    borderColor: "#0044C6", // keeps the same color on hover
                    backgroundColor: 'rgba(0, 68, 198, 0.04)', // optional subtle hover effect
                  }
                }}
                onClick={() => setShareModalOpen(true)}
              >
                Share Event
              </Button>


              <Divider sx={{ my: 3 }} />

              <Box sx={{ p: 1, display: "flex", gap: 2, width: "100%" }} >
                {event?.is_my_event && event?.no_of_attendees > 0 && (
                  <Button
                    variant="outlined"
                    fullWidth
                    size="large"
                    startIcon={<MdOutlineAnalytics sx={{ color: "#0044C6" }} />}
                    sx={{
                      py: 1,
                      color: "#0044C6",
                      borderColor: "#0044C6", // sets the outline color
                      '&:hover': {
                        borderColor: "#0044C6", // keeps the same color on hover
                        backgroundColor: 'rgba(0, 68, 198, 0.04)', // optional subtle hover effect
                      }
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent parent Paper onClick
                      handleViewDashboard(event)
                    }}
                  >
                    Dashboard
                  </Button>
                )}
              </Box>

              <AttendeesSection
                attendees={SAMPLE_ATTENDEES}
                limit={event?.attendees_limit}
                event={event}
              />

              {event?.event_access_level == "Private" ? <InviteesSection
                attendees={SAMPLE_ATTENDEES}
                limit={event?.attendees_limit}
                event={event}
              /> : ""}

              {availableSpots > 0 && availableSpots <= 10 && (
                <Box sx={{ mt: 3, p: 2, bgcolor: "#fff8e1", borderRadius: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}>
                    <WarningAmberOutlinedIcon color="warning" sx={{ mr: 1 }} />
                    <Typography variant="body2" fontWeight="medium">
                      Limited Slots available!
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    Only {availableSpots}{" "}
                    {availableSpots === 1 ? "Slot" : "Slots"} left for this event.
                  </Typography>
                </Box>
              )}
            </Paper>
          </Grid>
        </Grid>

        {event?.mode === "Offline" && event?.event_location && (
          <Paper
            elevation={0}
            sx={{ borderRadius: 2, p: 3, mt: 3, textAlign: "left" }}
          >
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Event Location
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              {event?.event_location}
            </Typography>
            {/* Show map using coordinates if available, else use address */}
            <Box
              sx={{
                width: "100%",
                height: 300,
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              {event?.latitude && event?.longitude ? (
                <MapIntegration
                  latitude={event?.latitude}
                  longitude={event?.longitude}
                />
              ) : (
                <MapWithAddress
                  address={event?.event_location}
                  mapheight="300px"
                />
              )}
            </Box>
          </Paper>
        )}

        {/* Media Modal */}
        {singleEvent?.media && singleEvent?.media?.length > 0 && (
          <MediaModal
            open={mediaModalOpen}
            onClose={() => setMediaModalOpen(false)}
            media={singleEvent?.media}
            currentIndex={currentMediaIndex}
            setCurrentIndex={setCurrentMediaIndex}
          />
        )}

        <TicketBookingModal
          open={bookingModalOpen}
          onClose={() => setBookingModalOpen(false)}
          event={event}
        />

        <Dialog open={isDeleteModalOpen} onClose={handleCloseDeleteModal}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this event?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeleteModal} color="primary">
              No
            </Button>
            <Button onClick={handleDeleteEvent} color="error">
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        {editModalOpen && (
          <CreateEventModal
            open={editModalOpen}
            onClose={() => setEditModalOpen(false)}
            editMode={true}
            eventData={event}
            onSubmit={async (formData) => {
              await dispatch(updateEvent({ id: event.id, data: formData }));
              setEditModalOpen(false);
            }}
          />
        )}

        <ShareProfile
          qrCodeUrl={eventShareUrl}
          open={shareModalOpen}
          onClose={() => setShareModalOpen(false)}
          profileType="event"
          showQr={true}
          isDownload={false}
          handleSuccess={handleShareSuccess}
          handleFailure={handleShareFailure}
          shareData={{
            title: event?.title,
            description: `Join us on ${new Date(event?.start_time).toLocaleDateString()} at ${formatTime(new Date(event?.start_time))}`,
            image: event?.feature_image,
            url: `${window.location.origin}/explore/events/${event?.id}`,
            start_time: event?.start_time,
            end_time: event?.end_time,
            location: event?.event_location || (event?.mode === "Online" ? "Online Event" : "Location not specified")
          }}
        />



        <Dialog
          open={ticketModalOpen}
          onClose={() => setTicketModalOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              background: "rgba(255,255,255,0.1)",
              backdropFilter: "blur(16px)",
              boxShadow: 24,
              borderRadius: 2,
              p: 0,
              minHeight: "80vh",
              width: "30%",
              scrollbarWidth: "none",
              position: "relative",
            },
            elevation: 0,
          }}
          sx={{
            "& .MuiDialog-container": {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: "blur(8px)",
              background: "rgba(0,0,0,0.3)",
            },
          }}
        >
          <Box
            sx={{ position: "relative", width: "100%", p: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <IconButton
              aria-label="close"
              onClick={() => setTicketModalOpen(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
                zIndex: 10,
              }}
            >
              <CloseIcon />
            </IconButton>
            <Box sx={{ display: "flex", justifyContent: "center", p: 0 }}>
              <TicketCard event={event} onClose={() => setTicketModalOpen(false)} />
            </Box>
          </Box>
        </Dialog>
      </Container>
    </>
  );
};

export default SingleEventScreen;
